export default __webpack_public_path__ + "static/media/prep_1.460475dd.svg";